// @ts-ignore
import type { Node } from 'react';
import DefaultLayout from '../DefaultLayout';

const PlayerLayout = ({ children }: { children: Node }) => (
  <DefaultLayout hasPlayer>{children}</DefaultLayout>
);

export default PlayerLayout;
